__turbopack_context__.v({
  "dark": "BJOloa_dark",
  "root": "BJOloa_root",
});
